module.exports = __webpack_public_path__ + "img/masterImg.b7a4d469.png";